import { render, staticRenderFns } from "./WidgetResumoVendasVendedor.vue?vue&type=template&id=7d38145d&scoped=true"
import script from "./WidgetResumoVendasVendedor.vue?vue&type=script&lang=ts"
export * from "./WidgetResumoVendasVendedor.vue?vue&type=script&lang=ts"
import style0 from "./WidgetResumoVendasVendedor.vue?vue&type=style&index=0&id=7d38145d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d38145d",
  null
  
)

export default component.exports